<template>
  <button
    :class="'BareIconButton Clickable ' + (classExtra || '')"
    v-on:click="onClick"
  >
    <img :src="'/img/icons/' + iconFalse + '.svg'" v-if="!value" />
    <img :src="'/img/icons/' + iconTrue + '.svg'" v-if="value" />
  </button>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import Countdown from "@/components/Countdown.vue";

@Component({ components: { Countdown } })
export default class TwoStateIconButton extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly iconFalse!: string;
  @Prop() readonly iconTrue!: string;
  @Prop({ required: false }) readonly classExtra!: string;
  @Prop() readonly onClick!: () => void;
}
</script>

<style scoped lang="scss"></style>
